import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import NavBar from './NavBar';
import TopBar from './TopBar';
import BottomBar from './BottomBar';
import useAuth from 'src/hooks/useAuth';
import { isPlantNewEwoFeatures } from 'src/utils/plantFeature';
import * as dataEwo from 'src/dataservice/dataEwo';
import * as dataTag from 'src/dataservice/dataTag';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 0
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

const TabletLayout = ({ children }) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    const source = new EventSource(process.env.REACT_APP_TABLELAYOUT_SSE_NOTIFICATIONS);

    const handleAlert = (event) => {
      if (event.lastEventId == localStorage.getItem("idteam")) {
        const isZedelgem = isPlantNewEwoFeatures(user?.plantdesc);
        if (isZedelgem) {
          const match = event.data.match(/New (EWO|Tag) (\d+) just assigned to team/i);
          if (match) {
            const type = match[1].toUpperCase();
            const docId = parseInt(match[2], 10);

            if (type === 'EWO') {
              dataEwo.getEwo(docId)
                .then(res => {
                  const ewo = res.data && res.data.data && res.data.data[0];
                  if (ewo) {
                    const isApproved = ewo.isApproved || ewo.isApprovedFromSap || ewo.IsApproved || ewo.IsApprovedFromSap;
                    if (isApproved) {
                      alert(event.data);
                    }
                  }
                })
                .catch(err => {
                  console.error("Error fetching EWO details for alert check", err);
                });
            } else if (type === 'TAG') {
              dataTag.getTag(docId)
                .then(res => {
                  const tag = res.data;
                  if (tag) {
                    const isApproved = tag.isApproved || tag.isApprovedFromSap || tag.IsApproved || tag.IsApprovedFromSap;
                    if (isApproved) {
                      alert(event.data);
                    }
                  }
                })
                .catch(err => {
                  console.error("Error fetching Tag details for alert check", err);
                });
            }
          } else {
            alert(event.data);
          }
        } else {
          alert(event.data);
        }
      }
    };

    source.addEventListener('alert', handleAlert);

    return () => {
      source.removeEventListener('alert', handleAlert);
      source.close();
    };
  }, [user]);

  return (
    <div className={classes.root}>
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />

      {/*  <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      /> */}
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>{children}</div>
        </div>
      </div>
      <BottomBar />
    </div>
  );
};

TabletLayout.propTypes = {
  children: PropTypes.node
};

export default TabletLayout;
